<template>
    <div>
        <div v-for="(sales, product) in value" :key="product" class="mb-1 row">
            <div class="col-lg-4 col-sm-12">{{ product }} - {{ sales.count }} шт.</div>
            <div class="col-lg-4 col-sm-12">{{ sales.sum }} {{ currency | currencySymbol }}</div>
            <div v-if="sales.net_sum" class="col-lg-4 col-sm-12">{{ sales.net_sum }} {{ currency | currencySymbol }} cost</div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        value: {
            type: Object,
            default: _ => ({})
        },
        currency: {
            type: Number,
            default: null
        }
    }
}
</script>

<style lang="scss" scoped>
i {
    cursor: pointer;
}

table {
    width: 100%;

    tr {
        td:first-child {
            text-align: left;
            font-weight: bold;
        }

        td:last-child {
            text-align: right;
        }
    }
}
</style>
